export default function StartFlag() {
  return <svg width="44" height="60" viewBox="0 0 44 60" aria-hidden="true">
    <ellipse cx="15" cy="49" rx="12" ry="3" fill="#8c8373" opacity=".16"/>
    <path d="M9 48V5" stroke="#8c8373" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M10 7C18 2 25 13 39 7L35 17L39 26C26 32 19 20 10 25Z" fill="#bda36e"/>
    <path d="M10 7C18 2 25 13 39 7L35 17C25 22 19 11 10 15Z" fill="#dbc792"/>
    <path d="M24 11C28 13 33 12 39 7L35 17L39 26C32 29 28 27 24 25Z" fill="#ac9265" opacity=".65"/>
    <path d="M11 8C18 5 23 13 31 12" fill="none" stroke="#eee1bd" strokeWidth="1" opacity=".7"/>
  </svg>;
}
